import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function Loading() {
  const LoadingRow = () => (
    <div className='h-14 pr-7 py-2.5 flex items-center'>
      <div className='ml-5 w-10 h-10'>
        <Skeleton className='h-10 rounded-lg' />
      </div>
      <div className='h-10 flex items-center'>
        <span className='pl-7 w-30'>
          <Skeleton />
        </span>
        <span className='ml-7 w-48'>
          <Skeleton />
        </span>
      </div>
    </div>
  );
  return <Skeleton wrapper={LoadingRow} count={5} />;
}
